module.exports = __webpack_public_path__ + "static/media/bell.4229af0e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/bell.svg
// module id = 260
// module chunks = 3